goog.provide("shadow.js.shim.module$react_bootstrap$TabContent$default");
shadow.js.shim.module$react_bootstrap$TabContent$default = shadow.js.require(367, {}).default;
